import {createAsyncThunk} from '@reduxjs/toolkit'
import {
  FetchEstablishementByIdRequest,
  UpdateEstablishementRequest,
  FetchEstablishementsRequest,
  CreateEstablishementRequest,
  DeleteEstablishementRequest,
  SuspendEstablishementRequest,
  ActivateEstablishementRequest,
  FetchAllEstablishementsRequest
} from './types'
import {AxiosError} from 'axios'
import {ResponseError} from '../commonTypes'
import {Establishement} from '../../../models'
import axios from 'axios'
import {
  fetchEstablishementsUrl,
  fetchEstablishementByIdUrl,
  createEstablishementUrl,
  updateEstablishementUrl,
  deleteEstablishementUrl,
  suspendEstablishementUrl,
  activateEstablishementUrl,
  fetchAllEstablishementsUrl
} from '../../api'

export const fetchEstablishements = createAsyncThunk(
  'establishement/fetch',
  async (payload: FetchEstablishementsRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(
        `${fetchEstablishementsUrl}?sortField=${payload.sortField}&sortOrder=${
          payload.sortOrder
        }&pageNumber=${payload.pageNumber}&pageCount=${payload.pageCount}${
          payload.search && payload.search.trim() !== '' ? '&search=' + payload.search.trim() : ''
        }`
      )
      const {establishements, totalPages, total} = res.data
      return {
        establishements,
        totalPages,
        total,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const fetchAllEstablishements = createAsyncThunk(
  'establishement/fetchAll',
  async (payload: FetchAllEstablishementsRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(
        `${fetchAllEstablishementsUrl}`
      )
      const {establishements} = res.data
      return {
        establishements,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const fetchEstablishementById = createAsyncThunk(
  'establishement/fetchById',
  async (payload: FetchEstablishementByIdRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(`${fetchEstablishementByIdUrl}/${payload.id}`)
      const {establishement} = res.data
      return {
        establishement,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const createEstablishement = createAsyncThunk(
  'establishement/create',
  async (payload: CreateEstablishementRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(createEstablishementUrl, payload)
      const {establishement} = res.data
      return {
        establishement,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const updateEstablishement = createAsyncThunk(
  'establishement/update',
  async (payload: UpdateEstablishementRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(updateEstablishementUrl, payload)
      const {establishement} = res.data
      return {
        establishement,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const deleteEstablishement = createAsyncThunk(
  'establishement/delete',
  async (payload: DeleteEstablishementRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(deleteEstablishementUrl, payload)
      const {establishement} = res.data
      return {
        establishement,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const suspendEstablishement = createAsyncThunk(
  'establishement/suspend',
  async (payload: SuspendEstablishementRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(suspendEstablishementUrl, payload)
      const {establishement} = res.data
      return {
        establishement,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const activateEstablishement = createAsyncThunk(
  'establishement/activate',
  async (payload: ActivateEstablishementRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(activateEstablishementUrl, payload)
      const {establishement} = res.data
      return {
        establishement,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)
